import { CONTRACT_STATES } from '@const'

export class ContractRecord {
  constructor (record) {
    this._record = record
    this.id = record.id
    this.contractor = record.contractor
    this.startDate = record.start_time
    this.endDate = record.end_time
    this.escrow = record.escrow
    this.contractNumber = record.initial_details.contract_number
  }

  get isDisputing () {
    return !!this._record.state.find(item => item.value === CONTRACT_STATES.disputing)
  }
}



// WEBPACK FOOTER //
// ./src/js/records/contract.record.js